<div class="container-fluid">
  <div class="row">
    <div class="col-11 d-flex bar ">


      <div class="tab-container">
        <div class="radiobtn">
          <input type="radio" name="tab" id="tab1" checked hidden>
          <label (click)="showoverview()" for="tab1" class="tab">
            <span>Overview</span>
          </label>

          <input type="radio" name="tab" id="tab2" hidden>
          <label (click)="showopentickit()" for="tab2" class="tab">
            <span class="d-flex justify-content-center align-items-center" id="opentickit">
              <span>Open tickets</span>
              <span *ngIf="opentickitnumber" class="tickitnumber ">{{TotalTicketsCount}}</span>
            </span>
          </label>




          <input type="radio" name="tab" id="tab3" hidden>
          <label (click)="showclosedtickit()" for="tab3" class="tab">

            <span>Closed tickets</span>
            <span *ngIf="closetickitnumber" class="tickitnumber">{{TotalTicketsCount}}</span>
          </label>
        </div>
        <div *ngIf="overview" class="droup">
          <select style=" height: 2rem;
            border: 1px solid #dddd;
            min-width: 9rem;
            padding-inline: 6px;
            border-radius: 8px;
            max-width: max-content;" [(ngModel)]="overviewFilter" (change)="OnOverviewFilterChange()">
            <option selected value="">All</option>
            <option value="this-month">This Month</option>
            <option value="last-month">Last Month</option>
            <option value="this-year">This Year</option>
            <option value="last-year">Last Year</option>
          </select>
        </div>
      </div>

    </div>
  </div>




  <div class="row g-0" *ngIf="overview">
    <div class="row g-0">
      <div class="col-11 d-flex just justify-content-between justify-content-center total-tickit">
        <div class=" d-flex gap-2 ">
          <span> <img src="/assets/HelpIcon/tickit.png" /></span>

          <p><b> Total Tickets </b></p>
        </div>
        <div>
          <h5>{{CountTotalTickets}}</h5>
        </div>
      </div>

    </div>
    <div class="row g-0">
      <div class="col-11 d-flex just justify-content-between justify-content-center total-tickit">
        <div class=" d-flex gap-2 ">
          <span> <img src="/assets/HelpIcon/tickit.png" /></span>

          <p><b> Open Tickets </b></p>
        </div>
        <div>
          <h5>{{CountOpenTickets}}</h5>
        </div>
      </div>

    </div>
    <div class="row g-0">
      <div class="col-11 d-flex just justify-content-between justify-content-center total-tickit">
        <div class=" d-flex gap-2 ">
          <span> <img src="/assets/HelpIcon/tickit.png" /></span>

          <p><b> Closed Tickets </b></p>
        </div>
        <div>
          <h5> {{CountClosedTickets}}</h5>
        </div>
      </div>

    </div>
  </div>



  <div *ngIf="!overview" class="row g-0">
    <div class="col-11 main-table">
      <div class="table-bar border-bottom d-flex justify-content-between align-items-center"
        style="padding-block: 10px; padding-inline: 20px;">
        <h5 *ngIf="!ShowClosedTickets">Open Tickets</h5>
        <h5 *ngIf="ShowClosedTickets">Closed Tickets</h5>

        <div class="sticky-top table-controls d-flex align-items-center gap-2">
          <div class="search-wrapper d-flex rounded position-relative" id="seachboxfirst">
            <img class="table-img me-2" src="/assets/userIcon/searchIcon.png" alt="Search" width="16" height="16" />
            <input class="input-search" type="text" placeholder="Search by name or email id" [(ngModel)]="searchText"
              (input)="onSearchChange(searchText)" />
          </div>

          <select aria-label="Booking Status" [(ngModel)]="SelectedFilter" style=" height: 2rem;
            border: 1px solid #dddd;
            min-width: 9rem;
            padding-inline: 6px;
            border-radius: 8px;
            max-width: max-content;" (change)="onStatusChange()">
            <option selected value="">All</option>
            <option value="this-month">This Month</option>
            <option value="last-month">Last Month</option>
            <option value="this-year">This Year </option>
            <option value="last-year">Last Year</option>
          </select>
        </div>
      </div>

      <div class="scrollable">
        <table class="table align-middle mb-0 border-1px ">
          <thead class="custom-head">
            <tr class="trow">
              <th scope="col" style="width: 20%;">Ticket ID</th>
              <th scope="col" style="width: 30%;">Title</th>
              <th scope="col" style="width: 20%;">User</th>
              <th scope="col" style="width: 20%;">Role</th>
              <th scope="col">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let ticket of AllTicketsDetails" style="border-bottom:1px solid #E7E7E7">
              <td>
                <span class="bookid">#{{ticket.ticketActivityId}}</span>
              </td>

              <td class="dates">
                {{ticket.subject}}
              </td>

              <td>
                <div class="d-flex align-items-center gap-2">
                  <img [src]='ticket.profilePhotoUrl || "assets/userIcon/user.png"' class="rounded-circle" width="40"
                    height="40" />
                  <div>
                    <div class="fw-semibold">{{ticket.firstName}} {{ticket.lastName}}</div>
                    <div class="text-muted small email">{{ticket.email}}</div>
                  </div>
                </div>
              </td>

              <td>
                <span class="tourist" *ngIf="ticket.roleName === 'Tourist'">
                  <img src="/assets/userIcon/tourist.png" /> Tourist
                </span>
                <span class="guide" *ngIf="ticket.roleName === 'TourGuide'">
                  <img src="/assets/userIcon/Guide.png" /> Guide
                </span>
              </td>

              <td class="action-img d-flex align-items-center gap-2">

                <div class="" style="display: flex; align-items: center; gap: 1rem;">
                  <div>
                    <img data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" (click)="getChatHistory(ticket)"
                      aria-controls="offcanvasRight" src="assets/userIcon/Action.svg" width="24" height="24" />
                  </div>

                  <div class="dropdown">
           
                    <img src="/assets/HelpIcon/dotIcon.svg" class="three-dot-btn p-0 text-muted fs-4" type="button"
                      data-bs-toggle="dropdown" aria-expanded="false" />
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item cursor " *ngIf="!ShowClosedTickets" style="font-weight: 500;"
                          (click)="closeticket(ticket.ticketActivityId)">Close Tickets</a></li>
                      <li><a class="dropdown-item text-danger cursor " style="font-weight: 500;"
                          (click)="deleteTicket(ticket.ticketActivityId)">Delete</a></li>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagenatiom">
        <app-pegination [pageAll]="PageNumber" [totalPages]="totalTicketPAges" [pageSize]="PageSize"
          (pageChange)="goToPages($event)" (sizeChange)="onSizeChanges($event)">
        </app-pegination>
      </div>
    </div>
  </div>

</div>









<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel"
  style="border-radius: 32px 0px 0px 32px;">
  <div class="canvaHead">
    <span class="canva-lbl" id="offcanvasRightLabel">Ticket Details</span>
    <button type="button" class="btn-close" (click)="closeChatCanvas()" data-bs-dismiss="offcanvas"
      aria-label="Close"></button>
  </div>
  <div class="offcanvas-body" style="padding-top: 0px;overflow-y: auto;border-top: 1px solid #E7E7E7;height: 93vh;padding-bottom: 0;">

    <div class="container-fluid" style="
    overflow: hidden;
    height: 100%;">
      <div _ngcontent-ng-c2634114619="" style="
    height: 100%;
">
        <div class="col-12 "style="
    height: 100%;
">


         <div _ngcontent-ng-c2634114619="" style="
    height: 64px;
">
            <div class="col-12 d-flex justify-content-center align-items-center gap-2 details">
              <span> <img src="/assets/HelpIcon/round.png" /></span>
              <b> Details</b>

            </div>
          </div>


     <div _ngcontent-ng-c2634114619="" style="
    height: 80px;
">
      
            <div class="col-12   d-flex justify-content-between tourist-cancva"                     style="
    height: 80%;
">
              <div class="d-flex align-items-center gap-2">
                <img [src]='SelectedTicket?.profilePhotoUrl' class="rounded-circle  " width="40" height="40" />
                <div class="name">
                  <div class="fw-semibold fs-md-6">{{SelectedTicket?.firstName}} {{SelectedTicket?.lastName}}</div>
                  <div class="text-muted small fs-md-6">{{SelectedTicket?.email}}</div>
                </div>
              </div>
              <span class="tourist" *ngIf="SelectedTicket?.roleName=='Tourist'">
                <img src="/assets/userIcon/tourist.png" class="me-1" /> Tourist
              </span>
              <span class="guide" *ngIf="SelectedTicket?.roleName=='TourGuide'">
                <img src="/assets/userIcon/Guide.png" class="me-1" /> Guide
              </span>

            </div>
          </div>



          <div class="" style=" height: 100px;" >
            <div class="12 d-flex gap-1 issue">
              <div style="border-right: 1px solid #E7E7E7; padding-right: 10px;">
                <span style="color: #6D6D6D; font-weight: 500; display: block;">Ticket ID</span>
                <span style="color: #000000; font-weight: 600;"> # {{SelectedTicket?.ticketActivityId}} </span>
              </div>
              <div class="d-flex  align-items-center issueoccur text-center">
                
                <p class="mb-0"><img class="img-fluid me-2" src="/assets/HelpIcon/Q.svg" alt="Issue Icon" style="height: 24px;"><b>Issue</b>: {{SelectedTicket?.subject}}</p>
              </div>



            </div>
          </div>


          <div class=" main-chat">
            <div style=" overflow-y: auto;" [ngClass]="{ 'emoji-open': showEmojiPicker }" #chatContainer>
              <div class="col-12" *ngFor="let msg of TicketChatHistory">
                <div class="chat-container" [ngClass]="{'flex-row-reverse': msg.roleId === 1}">

                 
                  <div class="guide-message">
                    <img [src]="getAvatarUrl(msg.roleId)" class="rounded-circle" width="42" height="42" />
                  </div>

                
                  <div class="message-box d-flex flex-column justify-content-center" [ngClass]="{
                  'admin-msg': msg.roleId == 1,
                   'tourist-msg': msg.roleId != 1
                  }">
                    <p class="mb-2">{{ msg.messageText }}</p>
                    <div class="time text-end">
                      <p class="mb-0" style="white-space: nowrap;"><small>{{ msg.sentAt | date:'shortTime' }}</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="Input-wrapper">

              <div class=" d-flex flex-column main-msg">
                <div class="d-flex">
                  <img src="/assets/HelpIcon/emoji.png" (click)="toggleEmojiPicker()" style="cursor:pointer">
                  <input class="d-flex align-items-center send-msg" (keydown.enter)="sendMessage()"
                    [(ngModel)]="MessageToSend" type="text" placeholder="Type Your Messages..." />

                  <span class="d-flex gap-2">

                    <img (click)="sendMessage()" src="/assets/HelpIcon/send.png" style="cursor:pointer">
                  </span>
                </div>
              </div>


              <div class="emoji-div" *ngIf="showEmojiPicker">
                <emoji-mart (emojiSelect)="addEmoji($event)"></emoji-mart>
              </div>
            </div>
          </div>

          

